import { render, staticRenderFns } from "./draw3DPieCanvas.vue?vue&type=template&id=4eb9c697&scoped=true&"
import script from "./draw3DPieCanvas.vue?vue&type=script&lang=js&"
export * from "./draw3DPieCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb9c697",
  null
  
)

export default component.exports